import { type z } from "zod";

import { externalIntegrationSchema } from "./external-integration-schema";
import { labelDataFormatSchema } from "./label-data-format-schema";

export const externalManagedConfigurationSchema = externalIntegrationSchema.safeExtend({
	labelDataFormat: labelDataFormatSchema,
});

export type ExternalManagedConfiguration = z.infer<typeof externalManagedConfigurationSchema>;
